import BASEURLGESTTOR from '../api/gesttor'

export function saldoContas () {
    return BASEURLGESTTOR.get('/dashboard/financeiro/saldocontas')
}

export function faturamentoMes () {
    return BASEURLGESTTOR.get('/dashboard/financeiro/faturamento')
}

export function despesasMes () {
    return BASEURLGESTTOR.get('/dashboard/financeiro/despesas')
}

export function faturamentoDespesas () {
    return BASEURLGESTTOR.get('/dashboard/financeiro/faturamentodespesa')
}

export function lucroMes () {
    return BASEURLGESTTOR.get('/dashboard/financeiro/lucro')
}

export function ticketMedio () {
    return BASEURLGESTTOR.get('/dashboard/financeiro/ticket')
}

export function dreMes () {
    return BASEURLGESTTOR.get('/dashboard/financeiro/dremes')
}

export function dreAno () {
    return BASEURLGESTTOR.get('/dashboard/financeiro/dreano')
}